import { render, staticRenderFns } from "./AppDownload.vue?vue&type=template&id=dad7e5da&"
import script from "./AppDownload.vue?vue&type=script&lang=ts&"
export * from "./AppDownload.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports